import { AppLayout } from '@/app/layout/components/app.layout';
import { Notfound } from '@/app/pages/notfound/notfound';
import { Routes } from '@angular/router';
import { authGuard } from '@/app/core/auth/guards/auth.guard';

export const appRoutes: Routes = [
    {
        path: '',
        component: AppLayout,
        canActivate: [authGuard],
        canActivateChild: [authGuard],
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'sales-electronic'
            },
            {
                path: 'categories',
                loadComponent: () => import('@/app/features/expenses/categories/categories.component').then((c) => c.CategoriesComponent),
                data: { breadcrumb: 'Categorías' }
            },
            {
                path: 'locations',
                loadComponent: () => import('@/app/features/expenses/locations/locations.component').then((c) => c.LocationsComponent),
                data: { breadcrumb: 'Localidades' }
            },
            {
                path: 'products',
                loadComponent: () => import('@/app/features/expenses/products/products.component').then((c) => c.ProductsComponent),
                data: { breadcrumb: 'Productos' }
            },
            {
                path: 'purchases-upload',
                loadComponent: () => import('@/app/features/expenses/purchases-upload/purchases-upload.component').then((c) => c.PurchasesUploadComponent),
                data: { breadcrumb: 'Compras' }
            },
            {
                path: 'providers',
                loadComponent: () => import('@/app/features/system/providers/providers.component').then((c) => c.ProvidersComponent),
                data: { breadcrumb: 'Proveedores' }
            },
            {
                path: 'customers',
                loadComponent: () => import('@/app/features/system/customers/customers.component').then((c) => c.CustomersComponent),
                data: { breadcrumb: 'Clientes' }
            },
            {
                path: 'sales-electronic',
                loadComponent: () => import('@/app/features/income/sales-electronic-v3/sales-electronic.component').then((c) => c.SalesElectronicComponent),
                data: { breadcrumb: 'Facturacion Electronica DTE 2.0' }
            },
            {
                path: 'sales-electronic-v3',
                redirectTo: 'sales-electronic',
                pathMatch: 'full'
            },
            {
                path: 'sales-electronic-pos',
                redirectTo: 'sales-electronic',
                pathMatch: 'full'
            },
            {
                path: 'sales-report',
                loadComponent: () => import('./app/features/reports/sales-report/sales-report.component').then((m) => m.SalesReportComponent),
                data: { breadcrumb: 'Informe de Ventas', memberAccess: true }
            },
            {
                path: 'reports-dashboard',
                loadComponent: () => import('@/app/features/reports/reports-dashboard/reports-dashboard.component').then((c) => c.ReportsDashboardComponent),
                data: { breadcrumb: 'Dashboard de Reportes', memberAccess: true }
            },
            {
                path: 'purchase-report',
                loadComponent: () => import('@/app/features/reports/purchase-report/purchase-report.component').then((c) => c.PurchaseReportComponent),
                data: { breadcrumb: 'Informe de Compras', memberAccess: true }
            },
            {
                path: 'sales-book-consumers',
                loadComponent: () => import('@/app/features/reports/sales-book-consumers/sales-book-consumers.component').then((c) => c.SalesBookConsumersComponent),
                data: { breadcrumb: 'Libro de Ventas para Consumidores', memberAccess: true }
            },
            {
                path: 'sales-book-taxpayers',
                loadComponent: () => import('@/app/features/reports/sales-book-taxpayers/sales-book-taxpayers.component').then((c) => c.SalesBookTaxpayersComponent),
                data: { breadcrumb: 'Libro de Ventas para Contribuyentes', memberAccess: true }
            },
            {
                path: 'annexes-consumers',
                loadComponent: () => import('@/app/features/reports/annexes-consumers/annexes-consumers.component').then((c) => c.AnnexesConsumersComponent),
                data: { breadcrumb: 'Anexos para Consumidores', memberAccess: true }
            },
            {
                path: 'annexes-taxpayers',
                loadComponent: () => import('@/app/features/reports/annexes-taxpayers/annexes-taxpayers.component').then((c) => c.AnnexesTaxpayersComponent),
                data: { breadcrumb: 'Anexos para Contribuyentes', memberAccess: true }
            },
            
        ]
    },
    {
        path: 'auth/login',
        loadComponent: () => import('@/app/features/auth/login/login.component').then((c) => c.LoginComponent)
    },
    
    { path: 'notfound', component: Notfound },
    { path: '**', redirectTo: '/auth/login' }
    
];
